import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@shared/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, type, 'aria-invalid': ariaInvalidProp, ...rest },
  ref,
) {
  const ariaInvalid = ariaInvalidProp ?? (invalid === true ? 'true' : undefined);

  return (
    <input
      ref={ref}
      type={type ?? 'text'}
      aria-invalid={ariaInvalid}
      className={cn(
        'flex h-11 w-full rounded-md border bg-surface px-3 py-2 text-base text-surface-fg',
        'placeholder:text-surface-fg/50',
        'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-60',
        invalid === true
          ? 'border-feedback-danger focus-visible:ring-feedback-danger'
          : 'border-surface-border',
        className,
      )}
      {...rest}
    />
  );
});
